import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20fashion%20lifestyle%20composition%20with%20carefully%20arranged%20premium%20clothing%20pieces%20on%20warm%20cream%20textured%20backdrop%2C%20soft%20diffused%20natural%20lighting%20from%20window%2C%20refined%20European%20minimalist%20aesthetic%2C%20subtle%20sage%20green%20accents%2C%20editorial%20product%20photography%2C%20no%20people%2C%20sophisticated%20warm%20neutral%20tones%2C%20clean%20harmonious%20arrangement%20with%20gentle%20shadows&width=1600&height=900&seq=oopbuy-hero-v2-01&orientation=landscape"
          alt="OOPBUY Spreadsheet – Produktübersicht mit stilvoller Modefotografie"
          title="OOPBUY Spreadsheet Produktübersicht"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div
          className={`transition-all duration-700 ease-out ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <h1 className="text-2xl md:text-5xl font-heading font-bold text-white leading-tight mb-4 md:mb-5">
            OOPBUY Spreadsheet – Die ultimative Produktübersicht für deutsche Käufer
          </h1>
          <p className="text-sm md:text-lg text-white/85 max-w-2xl mx-auto mb-7 md:mb-9 leading-relaxed">
            Finde beliebte Produkte, geprüfte Kategorien und hilfreiche Einkaufsinformationen mit dem OOPBUY Spreadsheet Guide. Strukturierte Übersichten für einen einfacheren Einkauf.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              OOPBUY Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3 text-sm font-semibold bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-lg hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              { icon: 'ri-checkbox-circle-line', text: 'Über 1000+ Produktideen' },
              { icon: 'ri-stack-line', text: 'Strukturierte Kategorien' },
              { icon: 'ri-guide-line', text: 'Anfängerfreundliche Guides' },
              { icon: 'ri-shield-check-line', text: 'Sicherheitsinformationen' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-white/80 text-xs md:text-sm">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-400 text-sm`}></i>
                </span>
                <span className="whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}